<template>
  <div v-if="item">
    <h5 v-if="item.business">Школа: {{ item.business.title }}</h5>
    <h5 v-if="item.group">Класс: {{ item.group.title }}</h5>
    <h5 v-if="item.client">Ученик: {{ item.client.full_name }}</h5>
    <h5 v-if="item.guardian">Родитель: {{ item.guardian.full_name }}</h5>
    <h5>Тариф: {{ item.tariff_name }}</h5>
    <!-- <h5>Количество детей: {{item.count}}/{{ item.client_count }}</h5> -->
    <h5>Платежная система: {{ item.payment_name }}</h5>
    <h5>Стоимость: {{ item.payment_cost | price }} {{ item.currency }}</h5>
    <h5>Период: {{ item.from_at | dateFormat }} - {{ item.till_at | dateFormat }}</h5>
    <h5>Дата оплаты: {{ item.paid_at | dateTimeFormat }}</h5>
    <h5>Дата отмены: {{ item.cancel_at | dateTimeFormat }}</h5>

    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <svg class="svg-angle svg-angle-1" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-2" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "transactions",
    cardSetLink: "transactions",
    item: null,
    fields: [
      {
        key: "is_paid",
        label: "Статус оплаты",
        type: 'checkbox',
      },
      {
        key: "is_active",
        label: "Активность подписки",
        type: 'checkbox',
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style>

</style>
